'use client';
import './CommunityJoinBar.css';

const CommunityJoinBar = () => {
    return (
        <div className="community-join-bar-container">
            <div className="community-bar">
                <div className="community-card whatsapp">
                    <div className="community-content">
                        <h4>
                            <img
                                src="/images/Footer/whatsapp.svg"
                                alt="WhatsApp Icon"
                                className="whatsapp-icon"
                            /> Join our whatsapp group
                        </h4>
                        <p>Stay Connected with Munich Indians Community</p>
                        <a
                            href="https://chat.whatsapp.com/G78JcFacUGB1ohRvwZPnrx"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="join-btn whatsapp-btn"
                        >
                            Click here to join
                        </a>
                    </div>
                </div>
                <div className="divider" />

                <div className="community-card reddit">
                    <div className="community-content">
                        <h4>
                            <img
                                src="/images/Footer/reddit.svg"
                                alt="Reddit Icon"
                                className="reddit-icon"
                            /> Join our Reddit group
                        </h4>
                        <p>A space for open, anonymous conversations on Reddit</p>
                        <a
                            href="https://www.reddit.com/r/MunichIndians/s/NP31Ux4UE3"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="join-btn reddit-btn"
                        >
                            Click here to join
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CommunityJoinBar;
